import AiChefDefault from "core/assets/icons/bottom_nav/ai_chef_default.svg";
import AiChefActive from "core/assets/icons/bottom_nav/ai_chef_active.svg";
// import FavoritesDefault from "core/assets/icons/bottom_nav/favorite_default.svg";
// import FavoritesActive from "core/assets/icons/bottom_nav/favorite_active.svg";
// import IngredientsDefault from "core/assets/icons/bottom_nav/ingredients_default.svg";
// import IngredientsActive from "core/assets/icons/bottom_nav/ingredients_active.svg";
// import MainDefault from "core/assets/icons/bottom_nav/main_default.svg";
// import MainActive from "core/assets/icons/bottom_nav/main_active.svg";
import MenuDefault from "core/assets/icons/bottom_nav/menu_default.svg";
import MenuActive from "core/assets/icons/bottom_nav/menu_active.svg";
import Discover from "core/assets/icons/bottom_nav/discover.svg";
import DiscoverActive from "core/assets/icons/bottom_nav/discover_active.svg";
import MyCooker from "core/assets/icons/bottom_nav/my_cooker.svg";
import MyCookerActive from "core/assets/icons/bottom_nav/my_cooker_active.svg";
import CommunityDefault from "core/assets/icons/bottom_nav/community_default.svg";
import CommunityActive from "core/assets/icons/bottom_nav/community_active.svg";

import { _t } from "core/language";
import { RouterName } from "core/router";
import { memo, useEffect, useState } from "react";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { AddRecipeByImageSwiperButton } from "modules/AiChef/components";
import { useDispatch } from "react-redux";
import { updateFavoriteListLocal } from "modules/Favorites/store/actions";
import { useRecipe } from "modules/Ingredients/hooks/recipe";
import { useResetRecipe } from "modules/Recipes/hooks/recipe";
import { resetSearchRecipe } from "modules/Recipes/store/actions";

const BottomNavigation = ({ activeIndex = 1, onNavigateChange }: any) => {
  const dispatch = useDispatch();
  const [index, setIndex] = useState<number>(activeIndex);
  const navigate = useCustomNavigate(true);
  const { setIngradients } = useRecipe();

  const onResetRecipe = useResetRecipe();
  const MenuItems = [
    {
      link: RouterName?.MAIN,
      menu: { default: Discover, active: DiscoverActive },
      text: _t("main.discover"),
    },
    {
      link: RouterName?.INGREDIENTS + "?tab=my-ingredient",
      menu: { default: MyCooker, active: MyCookerActive },
      text: _t("main.my_cooker"),
    },
    {
      link: RouterName?.AI_CHEF,
      menu: { default: AiChefDefault, active: AiChefActive },
      text: _t("main.ai_chef"),
    },
    // {
    //   link: RouterName?.FAVORITES,
    //   menu: { default: FavoritesDefault, active: FavoritesActive },
    //   text: _t("main.favorites"),
    // },
    {
      link: RouterName?.COMMUNITY_LIST,
      menu: { default: CommunityDefault, active: CommunityActive },
      text: _t("comunity.bottom_navigation"),
    },
    {
      link: RouterName?.MENU,
      menu: { default: MenuDefault, active: MenuActive },
      text: _t("main.menu"),
    },
  ];

  useEffect(() => {
    if (activeIndex) {
      setIndex(activeIndex);
    }
  }, [activeIndex]);

  const _navigate = (link: string) => {
    if(link !== RouterName?.FAVORITES) {
      dispatch(updateFavoriteListLocal({dataList:[],scrollPosition:0})); // RESTORE FAVORITE LIST
    }
    if(link !== RouterName?.SEARCH_RECIPES) {
      dispatch(resetSearchRecipe()); // RESTORE SEARCH RECIPE
    }
    
    onNavigateChange?.();
    // reset ingredients selected
    setIngradients([])
    onResetRecipe();
    navigate(link);
  };

  const renderMenu = () => {
    return MenuItems.map((item, k) => {
      const isActive = k === index - 1;
      const isAiChef = k === 2;

      const MenuContent = (
        <>
          <img
            src={isActive ? item.menu.active : item.menu.default}
            alt={item.text}
          />
          <p
            className={`text-[9px] text-[#333333] mt-1 ${
              isActive && isAiChef ? "text-white" : ""
            } ${isActive ? "text-[#FF6741]" : ""}`}
          >
            {_t(item.text)}
          </p>
        </>
      );
      const additionalClasses =
        k === 1 ? "" : k === 3 ? "" : "";
      return isAiChef ? (<div className=" rounded-full flex flex-col items-center ">
        <AddRecipeByImageSwiperButton
          key={k}
          className={
            "w-[60px] h-[60px] bg-[#FF6741] shadow-md box-shadow-navigation rounded-full flex flex-col inset-x-0 mx-auto items-center justify-center mt-[-16px]"
          }
        >
          <img src={item?.menu?.active} alt={item?.text} />
          <p className={`text-[9px] text-[#333333] mt-1 ${"text-white"}`}>
            {_t(item?.text)}
          </p>
        </AddRecipeByImageSwiperButton></div>
      ) : (
        <div
          key={k}
          className={`flex flex-col items-center w-[calc(100%/5-1px)] ${additionalClasses}`}
          onClick={() => _navigate(item.link)}
        >
          {MenuContent}
        </div>
      );
    });
  };

  return (
    <div className="fixed h-[60px] bottom-0 bg-white left-0 right-0 shadow-[0_0_20px_0px_#0000001F] z-50">
      <nav className="relative flex justify-between items-center py-[11px] h-[60px] w-full p-0">
        {renderMenu()}
      </nav>
    </div>
  );
};

BottomNavigation.displayName = "BottomNavigation";

export default memo(BottomNavigation);
